import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { STORIES_BASE_PATH } from "@/constants/routes";

export default function usePageType() {
  const pathname = usePathname();

  return useMemo(() => {
    const isMapPage = pathname.startsWith(`${STORIES_BASE_PATH}/map`);
    const isRecordPage = pathname.startsWith(`${STORIES_BASE_PATH}/record-gallery/`) && pathname.split('/').length === 5;
    const isStoryPage = pathname.startsWith(`${STORIES_BASE_PATH}/250-stories/`) && pathname.split('/').length === 4;

    return { isMapPage, isRecordPage, isStoryPage };
  }, [pathname]);
}
